import { defineStore } from 'pinia';
export const useMegaMenuStore = defineStore('megaMenuStore', {
  state() {
    return {
      menuSectionSettings: []
    };
  },
  actions: {
    setMegaMenuSettings(settings){
      this.menuSectionSettings = settings
    }
  },
});
